import React from 'react'
import HomeComponents from '../Components/Home/HomeComponents'

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from '../Components/Login/Login';
import Register from '../Components/Login/Register';
import Profile from '../Components/Profile/Profile';
import AuthCheck from './AuthCheck';
import LoginCheck from './LoginCheck';
import ProductList from '../Components/Project/ProductList';
import AddProduct from '../Components/Project/AddProduct';
import AddSlider from '../Components/Slider/AddSlider';
import SliderList from '../Components/Slider/SliderList';
import AddAbout from '../Components/About/AddAbout';
import AboutList from '../Components/About/AboutList';
import Aboutus from '../Components/Home/Aboutus';
import ServicesList from '../Components/Services/ServicesList';
import AddServices from '../Components/Services/AddServices';
import NewAbout from '../Components/About/NewAbout';
import Property from '../Components/Property/Property';
import PropertyList from '../Components/Property/PropertyList';
import PropertyDetail from '../Components/Property/PropertyDetail';
import NewService from '../Components/Services/NewService';
import ServiceDetail from '../Components/Services/ServiceDetail';
import Project from '../Components/Project/Project';
import Blog from '../Components/Blog/Blog';
import Blogdetail from '../Components/Blog/Blogdetail';
import BlogGrid from '../Components/Blog/BlogGrid';
import Contact from '../Components/Contact/Contact';
import Dashboard from '../Components/Home/Dashboard';
import Register2 from '../Components/Login/Register2';
import ForgetPassword from '../Components/Login/ForgetPassword';
import Deposit from '../Components/Home/Deposit';
import Assets from '../Components/Home/Assets';
import Withdrawladd from '../Components/Home/Withdrawladd';
import WithdrwalListMain from '../Components/Home/WithdrwalListMain';

import BankBox from '../Components/Home/BankBox';
import BankInfoCom from '../Components/Home/BankInfoCom';


import VisitSiteComponent2 from '../Components/Home/VisitSiteComponent2';
import Secure from '../Components/Login/Secure';
import AllTeams from '../Components/Account/AllTeams';
import DirectTeam from '../Components/Account/DirectTeam';
import RewardIncome from '../Components/Account/RewardIncome';
import DirectIncome from '../Components/Account/DirectIncome';
import RoylityIncome from '../Components/Account/RoylityIncome';
import FundRequest from '../Components/Account/FundRequest';
import MyOrderList from '../Components/Account/MyOrderList';
import Withdrawladd2 from '../Components/Home/Withdrawladd2';
import LevelIncome from '../Components/Account/LevelIncome';
import Bonanzalist from '../Components/Account/Bonanzalist';
import Bonanzadetail from '../Components/Account/Bonanzadetail';
import MapList from '../Components/Account/MapList';

function PageRoute() {
  return (
    <Routes>
      


      {/* public */}
        <Route path="/" element={<HomeComponents />} />
   
{/* user not authenticated */}
      <Route path="/login" element={<LoginCheck cmp={Login} />} />
        <Route path="/register" element={<LoginCheck cmp={Register} />} />
        <Route path="/register" element={<LoginCheck cmp={Register} />} />
        <Route path="/referalsignup" element={<LoginCheck cmp={Register2} />} />


        {/* user authenticated */}
        <Route path="/profile" element={<AuthCheck cmp={Profile} />} />
        <Route path="/product-list" element={< AuthCheck cmp={ProductList}/>} />
        <Route path="/add-product" element={< AuthCheck cmp={AddProduct}/>} />
        <Route path="/add-slider" element={< AuthCheck cmp={AddSlider}/>} />
        <Route path="/slider-list" element={< AuthCheck cmp={SliderList}/>} />
        <Route path="/add-about" element={< AuthCheck cmp={AddAbout}/>} />
        <Route path="/about-list" element={< AuthCheck cmp={AboutList}/>} />
        <Route path="/add-services" element={< AuthCheck cmp={AddServices}/>} />
        <Route path="/services-list" element={< AuthCheck cmp={ServicesList}/>} />
          <Route path="/deposit" element={<Deposit/>} />  
              <Route path="/assets" element={<Assets/>} />

         
        {/* website routes */}
        <Route path="/about_us" element={<Aboutus/>} />
              {/* website routes */}
        <Route path="/about" element={< NewAbout/>} />
          <Route path="/property" element={<Property />} />
             <Route path="/propertylist" element={<PropertyList />} />
              <Route path="/propertydetail" element={< PropertyDetail/>} />
                 <Route path="/service" element={< NewService/>} />
                 <Route path="/servicedetail" element={< ServiceDetail/>} />
                  <Route path="/project" element={< Project/>} />
                    <Route path="/projectdetail" element={< PropertyDetail/>} />
                       <Route path="/blog" element={< Blog/>} />
                                <Route path="/blogdetail" element={< Blogdetail/>} />
                                    <Route path="/bloggrid" element={< BlogGrid/>} />
                                       <Route path="/contact" element={< Contact/>} />
                                       <Route path="/dashboard" element={< Dashboard/>} /> 
                                              <Route path="/forget-Password" element={<ForgetPassword/>} />
                                                     <Route path="/withdrawladd" element={<Withdrawladd/>} /> 
                                                      <Route path="/withdrawl-list" element={<WithdrwalListMain/>} /> 
                                                      <Route path="/reacharge-list" element={<FundRequest/>} /> 
                                                       <Route path="/bankInfoCom" element={<BankInfoCom />} />
                                                       <Route path="/my-order" element={<MyOrderList/>} />
                                                          <Route path="/direct-team" element={<DirectTeam/>} />
                                                    <Route path="/bankBox" element={<BankBox />} /> 
                                                    <Route path="/all-team" element={<AllTeams/>} /> 
                                                     <Route path="/rewardIncome" element={<RewardIncome/>} />
                                                     <Route path="/roylity-income" element={<RoylityIncome/>} />
                                                       <Route path="/withdrawladd/:id" element={<Withdrawladd2/>} /> 
         <Route path="/map-list" element={<MapList/>} />                                                   
        <Route path="/direct-income" element={<DirectIncome/>} />
              <Route path="/level-income" element={<LevelIncome/>} />
               <Route path="/bonanza-list" element={<Bonanzalist/>} />
                      <Route path="/bonanza-detail/:id" element={<Bonanzadetail/>} />

                                                      <Route
        path="/visit-site"
        element={<VisitSiteComponent2 />}
      />     
           <Route path="/63bbf79290327404282cf563rd3/:id" element={<Secure />} />
           <Route path="/forget-Password" element={<ForgetPassword />} />                                 

        </Routes>
  )
}

export default PageRoute


